const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const sendSmsAllFields = [
  {
    id: "to",
    label:'Receiver Phone',
    placeholder: "Enter Receiver Phone",
    type: "contact",
    md:12,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },

  {
    id: "message",
    label: "Message",
    placeHolder: "Enter body",
    type: "textarea",
    isRequired: true,
    md: 12,
    minRows:3,
    inputProps: {
      maxLength: 1600,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    // editReadOnly: true,
  },
]
